import React from "react";
import { FaUser } from "react-icons/fa";
import { SiCashapp } from "react-icons/si";

import logo from "../../../images/diversos/logo rfinds empresarial branca.png";
import {
  Content,
  Logo,
  Fundo,
  ConteudoMenu,
  MenuBotao,
  Linkacesso,
} from "./styles";
import { Link } from "react-router-dom";

const Menu = () => {
  return (
    <Content>
      <Fundo>
        <Link to="/empresa">
          <Logo src={logo} alt="Rfinds Empresarial" />
        </Link>
        <ConteudoMenu>
          <MenuBotao to="/orcamentoecortedecustos">
            <SiCashapp color="#ffe" size="18" />
            <p>Calcule a redução dos custos</p>
          </MenuBotao>
          <Linkacesso href="http://rcontrol.com.br/rfleet/">
            <FaUser color="#ffe" size="18" />
            <p>Acesso do cliente</p>
          </Linkacesso>
        </ConteudoMenu>
      </Fundo>
    </Content>
  );
};

export default Menu;
